export enum ThreadType {
	Note = 1,
	FollowUp = 2,
	SupportRequest = 3
}
